import {useState} from 'react';
import { ajaxor2 } from "../common/basic";

export default (props = { items:[]})=>{
	const jsx = (<div className="submenu-bound">
		<style jsx>{`

.menu_box {
    border-bottom: solid 1px #dee2e6;
	background-color: #ffffff;
    width: 1290px;
	height: 400px;

	position: relative;
	z-index: 3;
	
	// box-shadow: 0 10px 10px 0 rgba(0, 0, 0, 0.08);

	line-height: 1;
	padding-top:50px;
}

.word-item{
	padding:16px 40px 16px 0;
}

@media all and (max-width:606px) {
	.menu_box {
		width: auto;
		padding-top: 30px;
		overflow-y: auto;
		border-bottom: 0;
		border-top: solid 1px #dee2e6;
	}
	
	
	.word-item{
		width: 49%;
		padding: 0;
		text-align: center;
		height: 60px;
		line-height: 20px;
		vertical-align: top;
	}

	.word-item a{
		vertical-align: middle;
	}

}

`}</style>
		<div className="menu_box">

			<div className="word-list">{(typeof props.items !== "undefined") && (props.items instanceof Array) && props.items.map((v, i, a) =>
				<div className="dib word-item"
					key={i}
					onClick={e => {
						ajaxor2({
							url: "/getLocationSlug?kw=" + v, // 슬러그얻기
							callback: cb
						});
						function cb(rd) {
							if (rd[0]) {
								location.href = "/community/location?kw=" + rd[0].slug;
							} else {
								alert("슬러그가 없는 메뉴입니다.");
							}
						}
					}}
				>&nbsp;<a >{v}</a>&nbsp;
				</div>
			)}</div>

		</div>

	</div>);
	return(jsx);
}

